module.exports = __webpack_public_path__ + "img/certificate-2-1.56f5cb5f.jpg";